import { get, post } from '../api.service';

export interface Customer {
    customerId: number;
    name: string;
    orgNo: string;
    ssn: string;
    reference: string;
    phoneNumber: string;
    email: string;
    secondaryEmailAddress: string;
    vatNumber: string;
    co: string | null;
    address: string;
    address2: string;
    city: string;
    zipCode: string;
    postAddress: string | null;
    postCity: string | null;
    postZipCode: string | null;
    postCountry: string | null;
    postCountryCode: string | null;
    isSecondaryEmailAddress: boolean;
    isActive: boolean;
    fortnoxCustomerId: string;
    invoice: any | null;
    timeSheet: any | null;
    invoiceApproval: any | null;
    customerAddress: any | null;
    country: string;
    paymentTerm: string;
    accountType: number;
    language: string;
    isNotes: boolean;
    countryCode: string;
    isAddedOnFortnox: boolean;
    isDetailsUpdatedOnFortnox: boolean;
    isVATRegistred: boolean;
    isCustomerUploadedToComplyCube: boolean | null;
    complyCubeApiResponse: any | null;
    isSsnValid: boolean | null;
    sparSsnInformation: any | null;
    createdBy: number;
    createdDate: string;
    updatedBy: number;
    updatedDate: string;
    isDeleted: boolean;
}

export interface UserInsuranceRecord {
    id: number;
    coverageStart: string;
    typeOfWork: string;
    insuranceterms: boolean;
    isActive: boolean;
    userId: number;
    customerId: number;
    customer: Customer;
    createdDate: string;
}

export interface UserInsuranceParams {
    PageNumber: number;
    PageSize: number;
}

export interface UserInsuranceResponse {
    statusCode: number;
    message: string;
    response: UserInsuranceRecord[];
    totalCount: number;
    numberOfPages: number;
}

export interface CreateUserInsuranceRequest {
    coverageStart: string;
    customerId: number;
    typeOfWork: string;
    insuranceConfirmation: boolean;
}

export interface CreateUserInsuranceResponse {
    statusCode: number;
    message: string;
    response: UserInsuranceRecord;
}

/**
 * Fetches user insurance records with pagination.
 * Corresponds to: GET /api/userinsurance?PageNumber=1&PageSize=10
 * @param params - The request parameters containing PageNumber and PageSize.
 * @returns The API response with user insurance data.
 */
export const fetchUserInsurance = async (params: UserInsuranceParams): Promise<UserInsuranceResponse> => {
    try {
        const response = await get('/userinsurance', {
            PageNumber: params.PageNumber,
            PageSize: params.PageSize,
        });
        return response;
    } catch (error) {
        console.error('Error fetching user insurance:', error);
        throw error;
    }
};

/**
 * Creates a new user insurance record.
 * Corresponds to: POST /api/userinsurance?language=sv-se
 * @param data - The user insurance data to create.
 * @param language - The language code for localized messages (e.g., 'sv-se', 'en')
 * @returns The API response with created user insurance record.
 */
export const createUserInsurance = async (data: CreateUserInsuranceRequest, language: string): Promise<CreateUserInsuranceResponse> => {
    try {
        const response = await post<CreateUserInsuranceResponse>(`/userinsurance?language=${language}`, data);
        return response;
    } catch (error) {
        console.error('Error creating user insurance:', error);
        throw error;
    }
};
